import { ThemeConfig, ThemeRegistry } from './types'
import { adventureTheme } from './adventure.theme'

class ThemeRegistryImpl implements ThemeRegistry {
  themes: Map<string, ThemeConfig>

  constructor() {
    this.themes = new Map()

    // Register built-in theme
    this.register(adventureTheme)
  }

  register(theme: ThemeConfig) {
    this.themes.set(theme.id, theme)
  }

  unregister(id: string) {
    this.themes.delete(id)
  }

  getTheme(id: string): ThemeConfig | undefined {
    return this.themes.get(id)
  }

  getAllThemes(): ThemeConfig[] {
    return Array.from(this.themes.values())
  }

  getServerThemes(): ThemeConfig[] {
    return this.getAllThemes().filter(t => t.source === 'server')
  }

  clearServerThemes() {
    for (const [id, theme] of this.themes) {
      if (theme.source === 'server') {
        this.themes.delete(id)
      }
    }
  }
}

// Export singleton instance
export const themeRegistry = new ThemeRegistryImpl()

// Helper function to add custom themes at runtime
export function registerCustomTheme(theme: ThemeConfig) {
  themeRegistry.register(theme)
}
